"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useOnScreen;

require("core-js/modules/web.dom-collections.iterator.js");

var _react = require("react");

function useOnScreen(ref) {
  let rootMargin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "0px";
  // State and setter for storing whether element is visible
  const [isIntersecting, setIntersecting] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    const observer = new IntersectionObserver(_ref => {
      let [entry] = _ref;
      // Update our state when observer callback fires
      setIntersecting(entry.isIntersecting);
    }, {
      rootMargin
    });

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      observer.unobserve(ref.current);
    };
  }, []); // Empty array ensures that effect is only run on mount and unmount

  return isIntersecting;
}